module.exports = __webpack_public_path__ + "static/media/8OLA9.ea0feee4.jpg";